<template>
  <v-container>
    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.only_read"
      label="Solo lectura"
    >
    </v-checkbox>

    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.is_electrovalvula"
      label="Electroválvula"
    >
    </v-checkbox>

    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.is_motor"
      label="Motor"
    >
    </v-checkbox>

    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.es_auto"
      label="Es auto"
    >
    </v-checkbox>

    <v-text-field
      prefix="Rotación:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.rotation"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.rotation == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.name"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Texto:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.text_bomb"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.text_bomb == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Motor:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_continuous_running"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_continuous_running == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Alarma:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_bomb_failure_alarm"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_bomb_failure_alarm == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      :disabled="selectedItem.customized.only_read"
      prefix="Orden marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_run_order"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_run_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.variable_is_auto_manual"
      label="Automático/Manual"
    >
    </v-checkbox>

    <v-text-field
      v-if="selectedItem.customized.variable_is_auto_manual"
      prefix="Lectura Auto/Manu:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.auto_manu_read_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.auto_manu_read_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      v-if="selectedItem.customized.variable_is_auto_manual"
      prefix="Texto auto:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.text_auto"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.text_auto == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      v-if="selectedItem.customized.variable_is_auto_manual"
      prefix="Texto marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.text_marcha"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.text_marcha == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Variator speed:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variator_speed_configuration?.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variator_speed_configuration?.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteBombCanvasQuesosProperties",

  computed: {
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),

    isNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        if (keyCode !== 46) {
          $event.preventDefault();
          return false;
        }
      }
    },
  },
};
</script>
